"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionValidationService = void 0;
var joi_1 = __importDefault(require("joi"));
var Result_1 = require("../../../../../models/concrete/Result");
var PromotionValidationService = /** @class */ (function () {
    function PromotionValidationService() {
        this.schemaForGetPromotions = joi_1.default.object().keys({
            page: joi_1.default.number().optional(),
            promotionId: joi_1.default.number().optional()
        });
        this.schemaForGetPromotionBySlug = joi_1.default.object().keys({
            slug: joi_1.default.string().required()
        });
    }
    PromotionValidationService.prototype.getPromotionsData = function (data) {
        var error = this.schemaForGetPromotions.validate(data).error;
        // debug
        console.debug('Validating get promotions data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    PromotionValidationService.prototype.getPromotionBySlugData = function (data) {
        var error = this.schemaForGetPromotionBySlug.validate(data).error;
        // debug
        console.debug('Validating get promotion by slug data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    return PromotionValidationService;
}());
exports.PromotionValidationService = PromotionValidationService;
//# sourceMappingURL=PromotionValidationService.js.map